import styled from "styled-components";

export const TableHeaderCommon = styled.div`
  ${(props) => `
    color: ${props.theme.colors.gray};
    font-family: ${props.theme.fontFamilies.primaryFont};
  `}
  font-size: 1.2rem;
  font-weight: 700;
  margin-bottom: 1rem;
  div {
    align-items: center;
    display: flex;
    flex-direction: column;
  }
  .main-info-header {
    align-items: flex-start;
  }
`;
interface IInvoicesContainer {
  gridTemplateColumns?: string;
}
export const InvoicesContainer = styled.div<IInvoicesContainer>`
  box-sizing: border-box;
  padding: 1.5rem 0rem;
  width: 100%;
  margin-top: 1rem;
  input.checkInvoice {
    margin-right: 2rem;
  }
  .attribute {
    margin: 0 !important;
  }
  .clickable-element {
    cursor: pointer;
  }
  .item-container {
    align-items: center;
    display: grid;
    grid-template-columns: ${(props) => props.gridTemplateColumns};
  }
  .titles {
    display: none;
  }
  @media (max-width: 750px) {
    & > div:first-of-type {
      display: none;
    }
    .titles {
      ${(props) => `
      color: ${props.theme.colors.gray};
      font-family: ${props.theme.fontFamilies.primaryFont};
    `}
      display: block;
      font-size: 1.2rem;
      font-weight: 700;
      justify-self: start;
      padding-left: 1rem;
    }
    div {
      padding: 0.2rem 0;
    }
    .item-container {
      grid-template-columns: 1fr;
      row-gap: 0.5rem;
    }
    .attribute {
      align-items: center !important;
      column-gap: 0.5rem;
      display: grid !important;
      grid-template-columns: minmax(9em, 30%) 1fr;
      justify-items: center;
      & > :not(.titles) {
        align-items: center;
        margin-left: 0;
        margin-right: 0;
        text-align: center;
        & > p {
          align-self: center;
        }
      }
    }
  }
`;

interface IInvoiceContainer {
  height?: string;
  marginBottom?: string;
}
export const InvoiceContainer = styled.div<IInvoiceContainer>`
  ${(props) => `
    background-color: ${props.theme.colors.white};
    color: ${props.theme.colors.blackTextTitle};
    font-family: ${props.theme.fontFamilies.primaryFont};
    height: ${props.height && props.height};
    margin-bottom: ${props.marginBottom ? props.marginBottom : "0rem"};
    @media (max-width: 750px) {
        height:auto;
    }
  `}
  border-radius: 1rem;
  display: grid;
  font-size: 1.4rem;
  font-weight: 500;
  padding: 0.5rem 1.5rem;
  border: 1px solid #dadada;
  div {
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  input.checkInvoice {
    margin-right: 2rem;
  }
  .actions {
    flex-direction: row;
    gap: 1rem;
  }
  .main-info-header {
    align-items: flex-start;
  }
  .main-info-header p {
    margin: 0.5rem 0;
  }
  .id {
    color: ${(props) => props.theme.colors.gray};
    font-size: 1.4rem;
    font-weight: 500;
  }
  .ruc-id {
    color: ${(props) => props.theme.colors.gray};
    font-size: 1.2rem;
    font-weight: 600;
  }
  .clickable-element {
    cursor: pointer;
  }
  .comment-box {
    align-items: center;
    align-self: center;
    background-color: ${({ theme }) => theme.colors.primaryBlue};
    border-radius: 1rem;
    display: flex;
    height: 3.4rem;
    justify-content: center;
    width: 3.4rem;
  }
`;
